/**
 * @generated SignedSource<<782a202a95cb3894b03a17351d1d4a69>>
 * @relayHash b0b89409f45955f1d6631ca601f67f8b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 916fc9c88cdf0763a685d23187d4deb77c6c3625098021bbc28d6dba182b8d9b

import type { ConcreteRequest } from 'relay-runtime';
export type graphqlHelpersFetchJiraMediaTokenQuery$variables = {
  issueAri: string;
  maxTokenLength?: number | null | undefined;
};
export type graphqlHelpersFetchJiraMediaTokenQuery$data = {
  readonly jira: {
    readonly issueById: {
      readonly mediaReadToken: {
        readonly clientId: string | null | undefined;
        readonly endpointUrl: string | null | undefined;
        readonly tokenLifespanInSeconds: AGG$Long | null | undefined;
        readonly tokensWithFiles: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly token: string | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type graphqlHelpersFetchJiraMediaTokenQuery = {
  response: graphqlHelpersFetchJiraMediaTokenQuery$data;
  variables: graphqlHelpersFetchJiraMediaTokenQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "issueAri"
  },
  {
    "defaultValue": 65536,
    "kind": "LocalArgument",
    "name": "maxTokenLength"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "issueAri"
  }
],
v2 = {
  "args": [
    {
      "kind": "Variable",
      "name": "maxTokenLength",
      "variableName": "maxTokenLength"
    }
  ],
  "concreteType": "JiraMediaReadToken",
  "kind": "LinkedField",
  "name": "mediaReadToken",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "clientId"
    },
    {
      "kind": "ScalarField",
      "name": "endpointUrl"
    },
    {
      "kind": "ScalarField",
      "name": "tokenLifespanInSeconds"
    },
    {
      "concreteType": "JiraMediaTokenWithFilesConnection",
      "kind": "LinkedField",
      "name": "tokensWithFiles",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraMediaTokenWithFilesEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraMediaTokenWithFiles",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "token"
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "graphqlHelpersFetchJiraMediaTokenQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issueById",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "graphqlHelpersFetchJiraMediaTokenQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraIssue",
            "kind": "LinkedField",
            "name": "issueById",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "name": "id"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "b0b89409f45955f1d6631ca601f67f8b",
    "id": "916fc9c88cdf0763a685d23187d4deb77c6c3625098021bbc28d6dba182b8d9b",
    "metadata": {},
    "name": "graphqlHelpersFetchJiraMediaTokenQuery",
    "operationKind": "query",
    "text": "query graphqlHelpersFetchJiraMediaTokenQuery($issueAri:ID!,$maxTokenLength:Int=65536){jira{issueById(id:$issueAri){mediaReadToken(maxTokenLength:$maxTokenLength)@optIn(to:\"JiraMediaReadTokenInIssue\"){clientId,endpointUrl,tokenLifespanInSeconds,tokensWithFiles{edges{node{token}}}},id}}}"
  }
};
})();

(node as any).hash = "7036cf95096a08504e6375127746a507";

export default node;
